import { useState } from 'react';
import { useQueryClient, useMutation } from 'react-query';

import API from '../constants/API';
import axios from '../constants/axios';
import useSimpleLoading from './useSimpleLoading';

const useProfileLike = ({ id, userType, initialIsLike }) => {
  const { onError } = useSimpleLoading();
  const queryClient = useQueryClient();
  const [isLiked, setIsLiked] = useState(initialIsLike);

  const updateLike = () => {
    setIsLiked((isLiked) => !isLiked);
    if (!queryClient.getQueryState([userType, `${id}`])) {
      return;
    }
    queryClient.setQueryData([userType, `${id}`], (user) => {
      if (user) {
        return {
          ...user,
          isLiked: !user.isLiked,
          likeCount: user.isLiked ? user.likeCount - 1 : user.likeCount + 1,
        };
      }
      return user;
    });
  };

  const likeMutation = useMutation(
    () => {
      return userType === 'tutor'
        ? axios.post(API.likeTutor, { tutorId: id })
        : axios.post(API.likeStudent, { studentId: id });
    },
    {
      onError,
      onSuccess: updateLike,
    },
  );

  return { likeMutation, isLiked };
};

export default useProfileLike;
